module.exports = __webpack_public_path__ + "static/media/left_arrow.6bd44bd9.svg";